import "./SettingsPanel.css";
import Divider from "../../components/ui/Divider";
import Button from "../../components/ui/Button";
import { useState } from "react";

function SettingRow({ title, description, options }) {
    return (
        <div className="setting-row">
            {/* Left column */}
            <div className="setting-left">
                <h4>{title}</h4>
                <p>{description}</p>
            </div>

            {/* Right column */}
            <div className="setting-right">
                {options.map((opt, idx) => (
                    <label key={idx} className="toggle-option">
                        <input
                            type="checkbox"
                            checked={opt.value}
                            onChange={opt.onChange}
                        />
                        <span className="toggle-slider"></span>
                        <span className="toggle-label">{opt.label}</span>
                    </label>
                ))}
            </div>
        </div>
    );
}

export default function SettingsPanel() {
    const [settings, setSettings] = useState({
        dashboardOwn: true,
        dashboardAll: true,
        dashboardFilter: false,
        responseMonitor: true,
        sendMessages: false,
        editTemplates: false,
        addAccounts: false,
        addOrganizations: false,
        editRoles: false,
        viewDocs: false,
        uploadDocs: false,
        deleteDocs: false,
        aiAccess: false,
        exportChats: false,
        deleteChats: false,
    });

    const toggle = key =>
        setSettings(prev => ({ ...prev, [key]: !prev[key] }));

    return (
        <div className="panel-wrapper">
            <h3>Gebruikers settings</h3>
            <p>Stel onderstaand de rechten in voor de gebruiker</p>
            <Divider mb={20} />

            <SettingRow
                title="Dashboard"
                description="Kan het dashboard raadplegen"
                options={[
                    { label: "Kan het dashboard raadplegen met inzichten van de eigen organisatie", value: settings.dashboardOwn, onChange: () => toggle("dashboardOwn") },
                    { label: "Kan het dashboard raadplegen met alle inzichten", value: settings.dashboardAll, onChange: () => toggle("dashboardAll") },
                    { label: "Kan filteren op overige organisaties", value: settings.dashboardFilter, onChange: () => toggle("dashboardFilter") }
                ]}
            />

            <SettingRow
                title="Respons en berichten"
                description="Deze instellingen hebben betrekking op de respons en berichten module"
                options={[
                    { label: "Kan de respons monitoren", value: settings.responseMonitor, onChange: () => toggle("responseMonitor") },
                    { label: "Kan berichten verzenden", value: settings.sendMessages, onChange: () => toggle("sendMessages") },
                    { label: "Kan sjablonen opslaan en bewerken", value: settings.editTemplates, onChange: () => toggle("editTemplates") }
                ]}
            />

            <SettingRow
                title="Accounts"
                description="Instellingen om de rollen en rechten van gebruikers te wijzigen en gebruikers en organisaties toe te voegen aan de omgeving."
                options={[
                    { label: "Accounts toevoegen en verwijderen", value: settings.addAccounts, onChange: () => toggle("addAccounts") },
                    { label: "Organisaties toevoegen of verwijderen", value: settings.addOrganizations, onChange: () => toggle("addOrganizations") },
                    { label: "Kan rollen en rechten aanpassen van gebruikers", value: settings.editRoles, onChange: () => toggle("editRoles") }
                ]}
            />

            <SettingRow
                title="Rapportages"
                description="These are notifications for posts on your profile, likes and other reactions to your posts, and more."
                options={[
                    { label: "Kan documenten inzien en downloaden", value: settings.viewDocs, onChange: () => toggle("viewDocs") },
                    { label: "Kan documenten uploaden", value: settings.uploadDocs, onChange: () => toggle("uploadDocs") },
                    { label: "Kan documenten verwijderen", value: settings.deleteDocs, onChange: () => toggle("deleteDocs") }
                ]}
            />

            <SettingRow
                title="AI Agent"
                description="Deze instellingen hebben betrekking op het kunnen gebruiken van de AI prompt"
                options={[
                    { label: "Kan de AI Agent benaderen", value: settings.aiAccess, onChange: () => toggle("aiAccess") },
                    { label: "Kan gesprekken exporteren", value: settings.exportChats, onChange: () => toggle("exportChats") },
                    { label: "Kan gesprekken verwijderen", value: settings.deleteChats, onChange: () => toggle("deleteChats") }
                ]}
            />

            <div className="save-bar">
                <h4>Je hebt alle instellingen.</h4>
                <p>Zodra de instellingen zijn opgeslagen zijn deze actief. Het kan zijn dat de gebruiker zijn scherm moet refreshen om (nieuwe) rechten te zien in zijn omgeving.</p>
                <Button variant="primary">
                    Opslaan
                </Button>
            </div>
        </div>
    );
}